<script lang="ts" setup>
const open = defineModel<boolean>('open')

function close() {
  open.value = false
}
</script>

<template>
  <USlideover
    v-model:open="open"
    title="Locaties"
    close-icon="bx:x"
    :ui="{
      body: 'p-0 sm:p-0',
      header: 'flex justify-between items-center p-3 sm:p-3',
    }"
  >
    <template #default>
      <slot />
    </template>
    <template #header>
      <h2>Locaties</h2>
      <div class="flex gap-3">
        <LocationsListHeaderGroupByToggle />
        <UButton icon="bx:x" variant="ghost" @click="close" />
      </div>
    </template>
    <template #body>
      <LocationsList />
    </template>
  </USlideover>
</template>
